module.exports = __webpack_public_path__ + "img/child-activity-cover.ad48d95f.png";